import { createTheme, Theme } from "@mui/material/styles";
import { orange, red } from "@mui/material/colors";

const palette = {
  primary: {
    main: red[500],
  },
  secondary: {
    main: orange[500],
  },
};

const typography = {
  fontFamily: ["Roboto", '"Helvetica Neue"', "sans-serif"].join(","),
};

export const lightTheme: Theme = createTheme({
  palette,
  typography,
});

export const darkTheme: Theme = createTheme({
  palette: {
    ...palette,
    mode: "dark",
  },
  typography,
});
